import {Authentication, CustomActionQueryParams} from "@/api/services";
import {CustomActionHeaders} from "@/api/services";
import {CustomActionBody} from "@/api/services";
import {LLMVariable} from "@/api/services";
import {QueryParameters} from "@/types/node";

export const convertActionAuthentication = (
  value: any,
): {child_type: string; authentication: Authentication} => {
  const key = Object.keys(value).find(key => value[key].selected === true);

  return {
    child_type: key || "",
    ...(key === "custom" && {
      authentication: {
        type: "bearer",
        location: "header",
        key: value?.[key]?.[`${key}_auth`]?.data?.key || "",
        value: value?.[key]?.[`${key}_auth`]?.data?.value || "",
      },
    }),
  };
};

export const convertActionHeaders = (
  value: any,
): {headers: CustomActionHeaders} => {
  return {
    headers: Object.fromEntries(
      Array.isArray(value)
        ? value
            .map((headerArr: any[]) => {
              const keyEntry = headerArr.find(
                (item: any) => item.key === "key",
              );
              const valueEntry = headerArr.find(
                (item: any) => item.key === "value",
              );
              return keyEntry && valueEntry
                ? [keyEntry.value, valueEntry.value]
                : [null, null];
            })
            .filter(([k, v]) => k !== null && v !== null)
        : [],
    ),
  };
};

export const convertActionBodyAndVariables = (
  value: any,
): {
  body: CustomActionBody;
  llm_vars: LLMVariable[];
  query_params: CustomActionQueryParams;
} => {
  return {
    body: JSON.parse(value?.json?.body || "{}"),
    llm_vars: Array.isArray(value?.variables?.variables)
      ? value.variables.variables.map((variableArr: any[]) => {
          const keyEntry = variableArr.find((item: any) => item.key === "key");
          const typeEntry = variableArr.find(
            (item: any) => item.key === "type",
          );
          const valueEntry = variableArr.find(
            (item: any) => item.key === "value",
          );
          const descriptionEntry = variableArr.find(
            (item: any) => item.key === "description",
          );
          return {
            name: keyEntry?.value || "",
            type: typeEntry?.value || "",
            example: valueEntry?.value || "",
            description: descriptionEntry?.value || "",
          };
        })
      : [],
    query_params: Object.fromEntries(
      Array.isArray(value?.query_parameters?.query_parameters)
        ? value.query_parameters.query_parameters
            .map((queryParamArr: any[]) => {
              const keyEntry = queryParamArr.find(
                (item: any) => item.key === "key",
              );
              const valueEntry = queryParamArr.find(
                (item: any) => item.key === "value",
              );
              return keyEntry && valueEntry
                ? [keyEntry.value, valueEntry.value || ""]
                : [null, null];
            })
            .filter(([k, v]) => k !== null && v !== null)
        : [],
    ),
  };
};

export const actionNodeTransform = {
  convertActionAuthentication,
  convertActionHeaders,
  convertActionBodyAndVariables,
};
